import { DateTime } from "luxon";

export type LuxonInput = string | number | Date | (string | number)[] | DateTime
